<template>
    <div class="py-3">
        <b-alert v-if="error" show variant="danger" class="mb-3">{{ error }}</b-alert>
        <b-alert v-if="success" show variant="success" class="mb-3">{{ success }}</b-alert>

        <b-form @submit.prevent="submitMerge">
            <div class="row">
                <div class="col-12 col-md-4">
                    <label class="akkurate-dark small d-none d-lg-block" for="sourceLoan">Source Loan Number</label>
                    <b-form-group label-for="sourceLoan" class="akkurate-dark">
                        <b-form-input id="sourceLoan" class="mt-2 field-container fields"
                            v-model.trim="form.source_loan_number"
                            placeholder="Enter source loan number"></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-12 col-md-4">
                    <label class="akkurate-dark small d-none d-lg-block" for="destLoan">Destination Loan
                        Number</label>
                    <b-form-group label-for="destLoan" class="akkurate-dark">
                        <b-form-input id="destLoan" class="mt-2 field-container fields"
                            v-model.trim="form.destination_loan_number"
                            placeholder="Enter destination loan number"></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-12 col-md-4">
                    <label class="akkurate-dark small d-none d-lg-block">&nbsp;</label>
                    <div class="d-grid gap-2 d-flex align-content-center justify-content-start mt-2">
                        <b-button type="submit" :disabled="isMerging"
                            class="akkurate-green-btn akkurate-auth-size d-flex align-items-center">
                            <font-awesome-icon v-if="!isMerging" :icon="['fas', 'object-group']" class="me-2" />
                            <b-spinner v-else small class="me-2" />
                            <span>Merge</span>
                        </b-button>
                    </div>
                </div>
            </div>
        </b-form>

        <hr />
        <div class="small text-muted">
            Notes:
            <ul class="mb-0">
                <li>All loan transactions, repayments and schedules from the source will be moved to the
                    destination.</li>
                <li>Balances and paid totals for the destination will be recalculated.</li>
                <li>The source loan will be marked as MERGED.</li>
            </ul>
        </div>
    </div>
</template>


<script>
import ApiService from '@/core/services/api.service';

export default {
    name: 'LoanMerge',
    data() {
        return {
            form: {
                source_loan_number: this.loan_number,
                destination_loan_number: '',
            },
            isMerging: false,
            error: '',
            success: ''
        }
    },
    props: ['loan_number'],
    // mounted() {
    //     const ln = this.$route?.query?.loan_number;
    //     if (ln) {
    //         this.form.source_loan_number = ln;
    //     }
    // },
    methods: {
        async submitMerge() {
            this.error = '';
            this.success = '';
            if (!this.form.source_loan_number || !this.form.destination_loan_number) {
                this.error = 'Please enter both source and destination loan numbers.';
                return;
            }
            if (this.form.source_loan_number === this.form.destination_loan_number) {
                this.error = 'Source and destination loan numbers must be different.';
                return;
            }
            try {
                this.isMerging = true;
                swal.fire({
                    title: "Please confirm",
                    html: `Are you sure you want to <strong>MERGE</strong> Transaction - From: <strong>${this.form.source_loan_number}</strong> To: <strong>${this.form.destination_loan_number}</strong>`,
                    icon: "info",
                    allowOutsideClick: true,
                    allowEscapeKey: true,
                    showCancelButton: true, // Show the "Cancel" button
                    confirmButtonText: "Merge", // Customize the text for the "OK" button
                    cancelButtonText: "No", // Text for the custom button
                    buttonsStyling: false, // Disable SweetAlert2 styling for buttons
                    customClass: {
                        confirmButton:
                            "btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
                        cancelButton:
                            "btn btn-size akkurate-gray-btn modal-btn-width text-white", // Custom class for the custom button
                    },
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        this.$Progress.start();
                        const { data } = await ApiService.post('/loans/merge', {
                            source_loan_number: this.form.source_loan_number,
                            destination_loan_number: this.form.destination_loan_number,
                        });
                        if (data?.status === 'success') {
                            this.success = data?.message || 'Loans merged successfully';
                            this.$bvToast && this.$bvToast.toast(this.success, { variant: 'success', autoHideDelay: 4000 });
                            this.$emit('loanMerged');
                        } else {
                            throw new Error(data?.message || 'Failed to merge loans');
                        }

                    }
                });
            } catch (e) {
                const msg = e?.response?.data?.message || e?.message || 'Failed to merge loans';
                this.error = msg;
                this.$bvToast && this.$bvToast.toast(msg, { variant: 'danger', autoHideDelay: 5000 });
            } finally {
                this.isMerging = false;
            }
        }
    }
}
</script>